import { render, staticRenderFns } from "./addressManage.vue?vue&type=template&id=3f2dee25&scoped=true&"
import script from "./addressManage.vue?vue&type=script&lang=js&"
export * from "./addressManage.vue?vue&type=script&lang=js&"
import style0 from "./addressManage.vue?vue&type=style&index=0&id=3f2dee25&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f2dee25",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/mnt/jenkins/workspace/product_operation/package_operation-saasmobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f2dee25')) {
      api.createRecord('3f2dee25', component.options)
    } else {
      api.reload('3f2dee25', component.options)
    }
    module.hot.accept("./addressManage.vue?vue&type=template&id=3f2dee25&scoped=true&", function () {
      api.rerender('3f2dee25', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/addressManage.vue"
export default component.exports